import {fromJS} from "immutable";
import {Reducer} from "redux";
import {IApplicationState} from "../types";
import {getGeoType} from "../../utils/getGeoType";
import {createPointSourceFeature} from "../../utils/createPointSourceFeature";
import {IFeature_CONO} from "../../types";

const updateEntity: Reducer<IApplicationState['map']> = (state, action): IApplicationState['map'] => {
    let mapStyle = state!.mapStyle;
    const {fullUid, type, patch, geometry, oldType} = action.payload;
    let fPath = ['sources', type, 'data', 'features'];
    const fPath_old = ['sources', oldType, 'data', 'features'];
    let features = oldType ? mapStyle.getIn(fPath_old) : mapStyle.getIn(fPath);
    let feature = features.find((f: any) => f.getIn(['properties', 'fullUid']) === fullUid);
    if (!feature) {
        feature = createFeature(geometry);
    }

    if (patch) {
        feature = feature.set('properties', feature.get('properties').merge(patch));
        if (oldType) {
            // remove old feature
            const features_old = mapStyle.getIn(fPath_old).filter(
                (f: any) => f.getIn(['properties', 'fullUid']) !== fullUid
            );
            mapStyle = mapStyle.setIn(fPath_old, features_old);
        }
    }
    if (geometry) {
        feature = feature.set('geometry', fromJS(geometry));
    }

    features = mapStyle.getIn(fPath).filter(
        (f: any) => f.getIn(['properties', 'fullUid']) !== fullUid
    ).push(feature);
    mapStyle = mapStyle?.setIn(fPath, features);
    return {...state, mapStyle} as IApplicationState['map'];
}

function createFeature (geometry) {
    const featureData = {
        type: 'Feature',
        geometry,
        properties: {}
    } as IFeature_CONO;
    const geoType = getGeoType(featureData).toLowerCase();
    return fromJS(
        (geoType === 'point') ? createPointSourceFeature(featureData) : featureData
    );
}

export { updateEntity };
